import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import type { KbArticleLink } from "@klantpunt/shared";
import { Modal } from "../../app/Modal";
import { api } from "../../lib/api";

/** "Artikel invoegen" (docs/HELPCENTER.md §5): zoek een gepubliceerd artikel en zet de link in het antwoord. */
export function ArticlePicker({ onPick, onClose }: { onPick: (a: KbArticleLink) => void; onClose: () => void }) {
  const [q, setQ] = useState("");
  const term = q.trim();
  const hits = useQuery({
    queryKey: ["helpcenter", "article-links", term],
    queryFn: () => api<KbArticleLink[]>(`/helpcenter/article-links?q=${encodeURIComponent(term)}`),
    placeholderData: (prev) => prev,
  });
  return (
    <Modal title="Artikel invoegen" onClose={onClose}>
      <label className="field">
        <span>Zoek een artikel</span>
        <input type="search" value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
      </label>
      <ul className="sp-picklist">
        {hits.data?.length === 0 && <li className="muted">Geen gepubliceerde artikelen gevonden.</li>}
        {(hits.data ?? []).map((a) => (
          <li key={a.id}>
            <button type="button" className="linkbtn" onClick={() => onPick(a)}>
              {a.title}
            </button>
            {a.visibility === "logged_in" && <span className="muted small"> · alleen in de app</span>}
          </li>
        ))}
      </ul>
    </Modal>
  );
}
